import { FAPI_EMPLOYEE_ENDPOINT } from '@/libs/constants/b2bApiEndpoints'
import type { UpdateEmployeeRequest } from '@/types/api/admin'
import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const apiClient = new HttpClient(environment.adminFAPIUrl)

export interface CreateEmployeeUserBody {
  userId: string
  userStatus: string
  language: string
}

export const adminEmployeeService = {
  async getUserEmployeesById(userId: string) {
    return apiClient.get(`${FAPI_EMPLOYEE_ENDPOINT}/${userId}`)
  },

  async getEmployeeSuggestionList(query: string) {
    const queryString = new URLSearchParams({ query })
    return apiClient.get(
      `${FAPI_EMPLOYEE_ENDPOINT}/suggestion?${queryString.toString()}`,
    )
  },

  async getEmployeeUserAvailableLanguages(employeeId: string) {
    const queryString = new URLSearchParams({ userId: employeeId })
    return apiClient.get(
      `${FAPI_EMPLOYEE_ENDPOINT}/available-languages?${queryString.toString()}`,
    )
  },

  async addEmployeeUser(data: CreateEmployeeUserBody) {
    return apiClient.post(`${FAPI_EMPLOYEE_ENDPOINT}/create`, { body: data })
  },

  async updateEmployee(data: UpdateEmployeeRequest) {
    return apiClient.put(`${FAPI_EMPLOYEE_ENDPOINT}/update`, {
      body: data,
    })
  },

  async deleteEmployeeAccount(userId: string) {
    return apiClient.delete(
      `${FAPI_EMPLOYEE_ENDPOINT}/delete?userId=${userId}`,
    )
  },
}
